module.exports = __webpack_public_path__ + "img/mingyong70.3d541ec0.png";